<script lang="ts" setup>
</script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="ic_warning">
      <g id="Group 3257">
        <g id="Group 3070">
          <circle
            id="Ellipse 173"
            cx="12"
            cy="12"
            r="9.25"
            transform="rotate(-180 12 12)"
            stroke="#4D4E58"
            stroke-width="1.5"
          />
          <path
            id="Vector 454"
            d="M12 6V9"
            stroke="#4D4E58"
            stroke-width="2"
          />
          <path
            id="Vector 455"
            d="M12 10V18"
            stroke="#4D4E58"
            stroke-width="2"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" scoped>
</style>
